"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateData = exports.cannotShowNegativeValues = exports.isNegativeValueIncluded = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var commonConfiguration_1 = require("../_chartCreators/commonConfiguration");
var limits_1 = require("../../constants/limits");
var common_1 = require("../_util/common");
var chartCapabilities_1 = require("./chartCapabilities");
var highChartsCreators_1 = require("../_chartCreators/highChartsCreators");
function isNegativeValueIncluded(series) {
    return series.some(function (seriesItem) {
        return (seriesItem.data || []).some(function (_a) {
            var y = _a.y, value = _a.value;
            return y < 0 || value < 0;
        });
    });
}
exports.isNegativeValueIncluded = isNegativeValueIncluded;
function getChartLimits(type) {
    switch (type) {
        case sdk_ui_1.VisualizationTypes.SCATTER:
            return {
                series: commonConfiguration_1.DEFAULT_SERIES_LIMIT,
                categories: commonConfiguration_1.DEFAULT_SERIES_LIMIT,
            };
        case sdk_ui_1.VisualizationTypes.PIE:
        case sdk_ui_1.VisualizationTypes.DONUT:
        case sdk_ui_1.VisualizationTypes.FUNNEL:
            return {
                series: 1,
                categories: limits_1.PIE_CHART_LIMIT,
            };
        case sdk_ui_1.VisualizationTypes.TREEMAP:
            return {
                series: commonConfiguration_1.DEFAULT_SERIES_LIMIT,
                categories: commonConfiguration_1.DEFAULT_DATA_POINTS_LIMIT,
                dataPoints: commonConfiguration_1.DEFAULT_DATA_POINTS_LIMIT,
            };
        case sdk_ui_1.VisualizationTypes.HEATMAP:
            return {
                series: commonConfiguration_1.DEFAULT_SERIES_LIMIT,
                categories: commonConfiguration_1.DEFAULT_CATEGORIES_LIMIT,
                dataPoints: limits_1.HEATMAP_DATA_POINTS_LIMIT,
            };
        default:
            return {
                series: commonConfiguration_1.DEFAULT_SERIES_LIMIT,
                categories: commonConfiguration_1.DEFAULT_CATEGORIES_LIMIT,
            };
    }
}
function cannotShowNegativeValues(type) {
    return common_1.isOneOfTypes(type, chartCapabilities_1.unsupportedNegativeValuesTypes);
}
exports.cannotShowNegativeValues = cannotShowNegativeValues;
function getTreemapDataForValidation(data) {
    // filter out root nodes
    return tslib_1.__assign(tslib_1.__assign({}, data), { series: data.series.map(function (serie) { return (tslib_1.__assign(tslib_1.__assign({}, serie), { data: serie.data.filter(function (dataItem) { return dataItem.id === undefined; }) })); }) });
}
function validateData(limits, chartOptions) {
    var type = chartOptions.type, isViewByTwoAttributes = chartOptions.isViewByTwoAttributes;
    var finalLimits = limits || getChartLimits(type);
    var dataToValidate = chartOptions.data;
    if (common_1.isTreemap(type)) {
        dataToValidate = getTreemapDataForValidation(chartOptions.data);
    }
    return {
        dataTooLarge: !highChartsCreators_1.isDataOfReasonableSize(dataToValidate, finalLimits, isViewByTwoAttributes),
        hasNegativeValue: cannotShowNegativeValues(type) && isNegativeValueIncluded(chartOptions.data.series),
    };
}
exports.validateData = validateData;
//# sourceMappingURL=chartLimits.js.map